//#region IMPORTS
import React, { Fragment, useState, useEffect, useMemo, useRef } from 'react';
import { ToastProvider, useToasts } from 'react-toast-notifications';
import {
  Container,
  Row,
  Col,
  FormGroup,
  ButtonGroup,
  Form,
} from 'react-bootstrap';

import LabelTitle from '../../components/Label/labelTitle';
import LoadingFieldData from '../../components/Loading/LoadingFieldData';
import LoadingTableData from '../../components/Loading/LoadingTableData';

import Button from '../../components/CustomButton/CustomButton';
import language from '../../config/es';
import { makeStyles } from '@material-ui/core/styles';
import Datetime from 'react-datetime';
import { es_vacio } from '../../config/validate';
import { formatDecimals } from '../../config/format';
import DataTable from 'react-data-table-component';
import Select from 'react-select';
//redux
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import { findSocieties } from '../../redux/society.duck';
import {
  getPermissions,
  findAllDocumentTypeForHistory,
  getFindAllPaymentHistoryByClient,
} from '../../redux/history.duck';
import { findByConcept } from '../../redux/type.duck';
//Session user
import SessionConfig from '../../config/session_config';
//Permissions
import dictionary from '../../config/dictionary';
//styles
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { BsCalendarWeekFill } from 'react-icons/bs';
import './styles.scss';
//#endregion IMPORTS

// Retorna el valor del filtro solo si el filtro está habilitado
const getEnabledFilterValue = (enabled, value) =>
  enabled === true ? value : '';

const History = () => {
  //#region VARIABLES_INIT
  const ref = useRef();
  const [showLoadingSociety, setShowLoadingSociety] = useState(true);

  const [lsHistory, setLsHistory] = useState([]);
  const [sortName, setSortName] = useState('dateIssue');
  const [sortOrder, setSortOrder] = useState('desc');
  const [pendingData, setPendingData] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const { addToast } = useToasts();
  const dispatch = useAppDispatch();

  const [data, setData] = useState({
    society: { value: 0, label: '', error: '' },
    societies: [],
    errors: [],
    enableSearch: false,
    restartSearch: false,
    action: dictionary.configApp.action,
    auth: JSON.parse(sessionStorage.getItem('user')),
  });
  const refreshData = () => {
    setData({ ...data });
  };
  const updateData = (value, id) => {
    setData({ ...data, [id]: value });
  };

  const [dataFilter, setDataFilter] = useState({
    loadingDocumentTypeForHistory: false,
    lsDocumentTypeForHistory: [],
    documentTypeForHistory: {value: '', label: '', error: '' },

    loadingStatusPaymentTypes: false,
    lsStatusPaymentType: [],
    statusPaymentType: { value: '', label: '', error: '' },
    docSAP: { value: '', error: '' },
    DNIClient: { value: '', error: '' },
    nameClient: { value: '', error: '' },

    dateInit: new Date(),
    dateEnd: new Date(),

    filterAdvance: false,
    filterDocSAP: false,
    filterDNIClient: false,
    filterNameClient: false,
    enableStatusPayment: false,
  });
  const refreshDataFilter = () => {
    setDataFilter({ ...dataFilter });
  };
  const updateDataFilter = (value, id) => {
    setDataFilter({ ...dataFilter, [id]: value });
  };

  const columns = useMemo(
    () => [
      {
        name: language.messages.history.gridColumClientName,
        sortable: true,
        width: '240px',
        wrap: true,
        cell: (row) => (
          <span>
            <div className=" text-capitalize small font-weight-bold">
              {row.clientName}
            </div>
          </span>
        ),
      },
      {
        name: language.messages.history.gridColumNumberBill1,
        sortable: true,
        wrap: true,
        cell: (row) => <div className="text-primary">{row.numberBill1}</div>,
      },
      {
        name: language.messages.monitor.sap,
        sortable: true,
        wrap: true,
        cell: (row) => (
          <div className=" text-capitalize small">{row.clientId}</div>
        ),
      },
      {
        name: language.messages.history.gridColumNumberDocumentSap,
        sortable: true,
        width: '130px',
        wrap: true,
        cell: (row) => <div className="">{row.numberDocumentSap}</div>,
      },
      {
        name: language.messages.history.gridColumAmount,
        sortable: true,
        wrap: true,
        right: true,
        cell: (row) => (
          <span className="text-end">
            <div className=" text-primary">
              { formatDecimals(
                Number.parseFloat(row.amount).toFixed(2).toLocaleString('en')
              )}
              <div className="badge bg-secondary small text-capitalize ms-2">
                {row.coinType}
              </div>
            </div>
          </span>
        ),
      },
      {
        name: language.messages.history.gridColumNumberBill2,
        sortable: true,
        width: '150px',
        wrap: true,
        cell: (row) => <div className=" small">{row.numberBill2}</div>,
      },
      {
        name: language.messages.history.gridColumDateIssue,
        sortable: true,
        wrap: true,
        cell: (row) => <div className="">{row.dateIssue}</div>,
      },
    ],
    []
  );

  //#endregion VARIABLES_INIT

  //#region REDUX
  data.societies = useSelector((store) => store.societyReducer.societies);
  dataFilter.lsDocumentTypeForHistory = useSelector(
    (store) => store.typeReducer.types
  );

  //#endregion REDUX

  //#region LIFECYCLE
  useEffect(() => {
    dataFilter.dateInit =onInitialDay();
    void initPermissions();
    void loadDataStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (dataFilter.lsDocumentTypeForHistory.length > 0) {
      void onChangeSelect(
        dataFilter.lsDocumentTypeForHistory[0],
        'documentTypeForHistory'
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataFilter.lsDocumentTypeForHistory]);
  useEffect(() => {
    ref.current.onRefreshCurrentSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataFilter, data]);
  //#endregion LIFECYCLE

  //#region LOAD_DATA
  //permisos
  const initPermissions = async () => {
    const res = await dispatch(
      getPermissions(data.auth.id.user.username, data.action.list)
    );
    if (res.response === undefined && res.data.allow === true) {
      void loadSocieties();
      void loadDocumentTypeForHistory();
    } else {
      viewNotification(res.response.data.error, 'warning');
    }
  };
  const loadSocieties = async () => {
    await dispatch(findSocieties(data.auth.id.user.userId));
    setShowLoadingSociety(false);
  };
  const loadDocumentTypeForHistory = async () => {
    dataFilter.loadingDocumentTypeForHistory = true;
    await dispatch(findAllDocumentTypeForHistory());
    dataFilter.loadingDocumentTypeForHistory = false;
    refreshDataFilter();
  };

  const loadDataStates = async () => {
    await dispatch(findByConcept(dictionary.configApp.concept.statusDocument));
  };
  const loadPaymentHistory = async (
    filterPage,
    sortColumnName,
    sortColumnOrder
  ) => {
    const json = {
      filter: {
        numberDocumentSap: getEnabledFilterValue(
          dataFilter.filterDocSAP,
          dataFilter.docSAP.value
        ),
        clientCode: '',
        clientCi: getEnabledFilterValue(
          dataFilter.filterDNIClient,
          dataFilter.DNIClient.value
        ),
        clientName: getEnabledFilterValue(
          dataFilter.filterNameClient,
          dataFilter.nameClient.value
        ),
        documentType: dataFilter.documentTypeForHistory.code,
        documentStatus: '',
        statusBillType:
          dataFilter.enableStatusPayment === true
            ? dataFilter.statusPaymentType.value
            : '',
        dateIssueInit: getDateFormat(dataFilter.dateInit),
        dateIssueEnd: getDateFormat(dataFilter.dateEnd),
      },
      sortField: sortColumnName == null ? sortName : sortColumnName,
      sortOrder: sortColumnOrder == null ? sortOrder : sortColumnOrder,
      pageNumber: filterPage.page,
      pageSize: filterPage.size,
    };

    try {
      let res = await dispatch(
        getFindAllPaymentHistoryByClient(data.society.value, json)
      );
      if (res.status === 200) {
        setLsHistory(res.data.entities);
        setTotalRows(res.data.totalCount);
        updateData(true, 'enableSearch');
      } else {
        switch (res.response.status) {
          case 403:
            viewNotification(res.response.data.error, 'error');
            setLsHistory([]);
            data.enableSearch = false;
            break;
          case 404:
            viewNotification(res.response.data.error, 'warning');
            setLsHistory([]);
            updateData(true, 'enableSearch');
            break;
          default:
            viewNotification(language.messages.msmErrorExist, 'error');
            setLsHistory([]);
            break;
        }
      }
    } catch (err) {
      console.error(err);
      viewNotification(language.messages.msmErrorExist, 'error');
      setPendingData(true);
    }
    setPendingData(false);
  };
  //#endregion LOAD_DATA

  //#region ONCHANGE_DATA
  const onChangeField = (event) => {
    switch (event.target.name) {
      case 'docSAP':
        dataFilter.docSAP.value = event.target.value;
        dataFilter.docSAP.error = '';
        break;
      case 'DNIClient':
        dataFilter.DNIClient.value = event.target.value;
        dataFilter.DNIClient.error = '';
        break;
      case 'nameClient':
        dataFilter.nameClient.value = event.target.value;
        dataFilter.nameClient.error = '';
        break;
      default:
        break;
    }
    refreshDataFilter();
  };
  const onChangeDateInit = (date) => {
    dataFilter.dateInit = date._d;
    updateDataFilter(date._d, 'dateInit');
  };

  const onInitialDay = () => {
    const currentDate = new Date().getFullYear();
    const newDate = new Date('01/01/' + currentDate);
    return newDate;
  };

  const onChangeDateEnd = (date) => {
    dataFilter.dateEnd = date._d;
    updateDataFilter(date._d, 'dateEnd');
  };
  const onChangeSelect = async (value, id) => {
    switch (id) {
      case 'society':
        data.society = value || '';
        data.enableSearch = true;
        data.restartSearch = true;
        refreshDataFilter();
        break;
      case 'documentTypeForHistory':
        dataFilter.documentTypeForHistory = value;
        break;
      case 'statusPaymentType':
        dataFilter.statusPaymentType = value;
        break;
      case 'filterAdvance':
        dataFilter.filterAdvance = value.target.checked;
        dataFilter.filterAdvance === true
          ? viewNotification(language.messages.msmAdvanceFilter, 'success')
          : viewNotification(
              language.messages.msmRemoveAdvanceFilter,
              'warning'
            );
        break;
      case 'filterDocSAP':
        dataFilter.filterDocSAP = value.target.checked;
        if (dataFilter.filterDocSAP)
          viewNotification(
            language.messages.msmAddOptionFilter.replace(
              '{0}',
              language.messages.history.filterDocSAP
            ),
            'info'
          );
        else {
          viewNotification(
            language.messages.msmRemoveOptionFilter.replace(
              '{0}',
              language.messages.history.filterDocSAP
            ),
            'warning'
          );
          dataFilter.docSAP.value = '';
        }
        break;
      case 'filterDNIClient':
        dataFilter.filterDNIClient = value.target.checked;
        if (dataFilter.filterDNIClient)
          viewNotification(
            language.messages.msmAddOptionFilter.replace(
              '{0}',
              language.messages.history.filterDNIClient
            ),
            'info'
          );
        else {
          viewNotification(
            language.messages.msmRemoveOptionFilter.replace(
              '{0}',
              language.messages.history.filterDNIClient
            ),
            'warning'
          );
          dataFilter.DNIClient.value = '';
        }
        break;
      case 'filterNameClient':
        dataFilter.filterNameClient = value.target.checked;
        dataFilter.filterNameClient === true
          ? viewNotification(
              language.messages.msmAddOptionFilter.replace(
                '{0}',
                language.messages.history.filterNameClient
              ),
              'info'
            )
          : viewNotification(
              language.messages.msmRemoveOptionFilter.replace(
                '{0}',
                language.messages.history.filterNameClient
              ),
              'warning'
            );
        break;
      default:
        break;
    }
    refreshDataFilter();
  };
  //#endregion ONCHANGE_DATA

  //#region STYLES
  const useStyles = makeStyles((theme) => ({
    root: {
      padding: theme.spacing(2),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    tableWrapper: {
      overflowX: 'auto',
    },
    marginButtonTop: {
      marginTop: theme.spacing(3),
    },
    marginCol: {
      marginLeft: '10px',
      marginRight: '10px',
    },
  }));
  const classes = useStyles();
  //#endregion STYLES

  //#region FUNCTIONS
  const getDateFormat = (date) => {
    const startMonth = date.getMonth() + 1 + '';
    const startDay = date.getDate() + '';
    const startDate =
      date.getFullYear() +
      '-' +
      startMonth.padStart(2, '0') +
      '-' +
      startDay.padStart(2, '0');
    return startDate;
  };
  const viewNotification = (msm, action) => {
    addToast(msm, {
      appearance: action,
      autoDismiss: true,
    });
  };
  //#endregion FUNCTIONS

  //#region FUNCTIONS_FORM
  
  const clearError = () => {
    data.errors = [];
    data.society.error = '';
    dataFilter.documentTypeForHistory.error = '';
    dataFilter.statusPaymentType.error = '';
    dataFilter.docSAP.error = '';
    dataFilter.DNIClient.error = '';
    dataFilter.nameClient.error = '';
  };
  const validateAdvanceFilter = () => {
    if (
      es_vacio(dataFilter.documentTypeForHistory.value) &&
      dataFilter.documentTypeForHistory.label !== 'Todos'
    ) {
      data.errors.push('documentTypeForHistory.error');
      data.documentTypeForHistory.error =
        language.messages.warning_required_field;
    }
    if (dataFilter.filterDocSAP === true && es_vacio(dataFilter.docSAP.value)) {
      data.errors.push('docSAP.error');
      dataFilter.docSAP.error = language.messages.warning_required_field;
    }
    if (
      dataFilter.filterDNIClient === true &&
      es_vacio(dataFilter.DNIClient.value)
    ) {
      data.errors.push('DNIClient.error');
      dataFilter.DNIClient.error = language.messages.warning_required_field;
    }
    if (
      dataFilter.filterNameClient === true &&
      es_vacio(dataFilter.nameClient.value)
    ) {
      data.errors.push('nameClient.error');
      dataFilter.nameClient.error = language.messages.warning_required_field;
    }
    if (
      dataFilter.enableStatusPayment === true &&
      es_vacio(dataFilter.statusPaymentType.value) &&
      dataFilter.statusPaymentType.label !== 'Todos'
    ) {
      data.errors.push('statusPaymentType.error');
      dataFilter.statusPaymentType.error =
        language.messages.warning_required_field;
    }
  };
  const validate = () => {
    clearError();
    if (es_vacio(data.society.value)) {
      data.errors.push('documentTypeForHistory.error');
      data.society.error = language.messages.warning_required_field;
    }
    if (dataFilter.filterAdvance === true) {
      validateAdvanceFilter();
    }
    refreshData();
  };
  const searchDataHistoryPaymentClient = async () => {
    validate();
    if (data.errors.length === 0) {
      clearError();
      setPendingData(true);
      updateData(false, 'enableSearch');
      const filterPage = {
        page: currentPage,
        size: perPage,
      };
      await loadPaymentHistory(filterPage, sortName, sortOrder);
      updateData(true, 'enableSearch');
    } else {
      viewNotification(language.messages.msmErrorForm, 'error');
    }
  };
 
  //#endregion FUNCTIONS_FORM

  //#region FUNCTIONS_DATA_TABLE
  const paginationOptions = {
    rowsPerPageText: language.messages.rowsPerPageText,
    rangeSeparatorText: language.messages.rangeSeparatorText,
    selectAllRowsItem: true,
    selectAllRowsItemText: language.messages.selectAllRowsItemText,
  };
  const handlePageChange = async (page) => {
    setPendingData(true);
    const filterPage = {
      page: page,
      size: perPage,
    };
    void loadPaymentHistory(filterPage, sortName, sortOrder);
    setCurrentPage(page);
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    setPendingData(true);
    const filterPage = {
      page: page,
      size: newPerPage,
    };
    void loadPaymentHistory(filterPage, sortName, sortOrder);
    setPerPage(newPerPage);
  };
  const customSort = (field, sortDirection) => {
    const filterPage = {
      page: currentPage,
      size: perPage,
    };
    void loadPaymentHistory(filterPage, field.selector, sortDirection);
    setSortName(field.selector);
    setSortOrder(sortDirection);
  };

  //#endregion FUNCTIONS_DATA_TABLE

  return (
    <Fragment>
      <SessionConfig ref={ref} />
      <Container fluid={true}>
         
        <Paper elevation={3} variant="outlined" className={classes.root}>
          <Row>
            <Col>
              <Typography gutterBottom variant="h5">
                {language.messages.history.titleHistory}
              </Typography>
            </Col>
          </Row>
          <Fragment>
            <form autoComplete="on">
              <Row className="align-items-end">
                <Col xs={12} sm={12} md={3} lg={3}>
                  <FormGroup>
                    <LabelTitle
                      text={language.messages.history.filterSociety}
                    />
                    <Select classNamePrefix="ui-select"
                      isClearable={true}
                      placeholder={language.messages.lblSingleSelect}
                      name="society"
                      options={data.societies}
                      className="text-uppercase small"
                      value={{
                        value: data.society.value,
                        label: data.society.label,
                      }}
                      onChange={(value) => {
                        void onChangeSelect(value, 'society');
                      }}
                    />
                    <LoadingFieldData showloading={showLoadingSociety} />
                    <span className="small text-danger">
                      {data.society.error}
                    </span>
                  </FormGroup>
                </Col>

                <Col xs={12} sm={12} md={6} lg={4}>
                  <Row>
                    <Col>
                      <FormGroup className="inline">
                        <LabelTitle
                          text={language.messages.history.labelDateIssueInit}
                        />
                        <div className="input-icons">
                          <Datetime
                            className="custom-datePicker input-field"
                            timeFormat={false}
                            initialValue={onInitialDay()}
                            onChange={onChangeDateInit}
                            dateFormat="DD/MM/YYYY"
                            type="date"
                          ></Datetime>
                          <BsCalendarWeekFill className="icon" />
                        </div>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <LabelTitle
                          text={language.messages.history.labelDateIssueEnd}
                        />
                        <div className="input-icons">
                          <Datetime
                            timeFormat={false}
                            initialValue={new Date()}
                            onChange={onChangeDateEnd}
                            dateFormat="DD/MM/YYYY"
                          ></Datetime>
                          <BsCalendarWeekFill className="icon" />
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} sm={12} md={3} lg={2}>
                  <Row>
                    <Col className={classes.marginCol}>
                      <FormGroup>
                        <LabelTitle
                          text={
                            language.messages.history.filterStatusPaymentType
                          }
                        />
                        <Select classNamePrefix="ui-select"
                          placeholder={language.messages.lblSingleSelect}
                          name="documentTypeForHistory"
                          options={dataFilter.lsDocumentTypeForHistory}
                          className="text-uppercase small"
                          value={{
                            ...dataFilter.documentTypeForHistory,
                          }}
                          onChange={(value) => {
                            void onChangeSelect(value, 'documentTypeForHistory');
                          }}
                          size="sm"
                        />
                        <LoadingFieldData
                          showloading={dataFilter.loadingDocumentTypeForHistory}
                        />
                        <span className="small text-danger">
                          {dataFilter.documentTypeForHistory.error}
                        </span>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} sm={3} md={2} lg={2}>
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        checked={dataFilter.filterDocSAP}
                        name="filterDocSAP"
                        onChange={(value) => {
                          void onChangeSelect(value, 'filterDocSAP');
                        }}
                      />
                    }
                    label={language.messages.history.filterDocSAP}
                    labelPlacement="start"
                  />
                  <FormGroup>
                    <Form.Control
                      disabled={dataFilter.filterDocSAP === false}
                      maxLength={15}
                      size="sm"
                      type="text"
                      name="docSAP"
                      id="docSAP"
                      placeholder={language.messages.history.labelDocSAP}
                      value={dataFilter.docSAP.value}
                      onChange={onChangeField}
                    />
                    <span className="small text-danger">
                      {dataFilter.docSAP.error}
                    </span>
                  </FormGroup>
                </Col>
                <Col xs={12} sm={3} md={2} lg={2}>
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        checked={dataFilter.filterDNIClient}
                        name="filterDNIClient"
                        onChange={(value) => {
                          void onChangeSelect(value, 'filterDNIClient');
                        }}
                      />
                    }
                    label={language.messages.monitor.sap}
                    labelPlacement="start"
                  />
                  <FormGroup>
                    <Form.Control
                      disabled={dataFilter.filterDNIClient === false}
                      maxLength={15}
                      size="sm"
                      type="text"
                      name="DNIClient"
                      id="DNIClient"
                      placeholder={language.messages.monitor.sap}
                      value={dataFilter.DNIClient.value}
                      onChange={onChangeField}
                    />
                    <span className="small text-danger">
                      {dataFilter.DNIClient.error}
                    </span>
                  </FormGroup>
                </Col >
 
                    <Col sm={3} md={2} lg={2}>
                    
                      <ButtonGroup>
                        <Button
                          disabled={!data.enableSearch}
                          success
                          fill
                          type="button"
                          size="large"
                          onClick={searchDataHistoryPaymentClient}
                        >
                          <i className="fa fa-search"></i>{' '}
                          {language.messages.history.btnSearch}
                        </Button>
                      </ButtonGroup>
                       
                    </Col>
                  
                
              </Row>
            </form>
            <hr/>
            <DataTable
              data={lsHistory}
              columns={columns}
              fixedHeader
              fixedHeaderScrollHeight="600px"
              dense
              pointerOnHover={true}
              highlightOnHover
              pagination
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              paginationServer
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              onSort={customSort}
              sortServer
              paginationComponentOptions={paginationOptions}
              progressPending={pendingData}
              progressComponent={<LoadingTableData />}
              persistTableHead
            />
          </Fragment>
        </Paper>
      </Container>
    </Fragment>
  );
};
const App = () => (
  <ToastProvider>
    <History />
  </ToastProvider>
);
export default App;
